module.exports = __webpack_public_path__ + "img/01.e28249c8.jpg";